@if (displayConditionalStyling) {
  <section>
    <h4>Conditional Styling</h4>
    @if (hasOperators) {
      <div class="flex flex-col w-full">
        @if (!isFormEmpty) {
          <span>{{ fieldLabel }}</span>
          <ts-flow-connector class="pl-4 h-3" type="|" />
        }
        @for (
          control of conditionFormattingFormArray.controls;
          track $index;
          let first = $first;
          let last = $last;
          let count = $count
        ) {
          @if (control.get('_destroy')?.value !== true) {
            <form [formGroup]="control">
              <div class="pl-4 flex flex-row">
                @if ((first && count - controlsMarkedForDestroyCount === 1) || last) {
                  <ts-flow-connector type="L" />
                } @else {
                  <ts-flow-connector type="T" />
                }
                <div class="border rounded flex flex-row pt-3 pb-1 px-4 mb-2">
                  <!-- <p class="mt-2 w-4">{{ getConditionRank($index) + '.' }}</p> -->
                  <ts-filter-list-item
                    [index]="$index"
                    [displayFieldSelection]="false"
                    [isValueBold]="control.get('is_bold')?.value"
                    [valueBackgroundColor]="control.get('color')?.value?.hex_value"
                    [fields]="fieldFilterData()"
                    [filter]="selectedFilterData()[$index]"
                    [lookupContract]="lookupService"
                    [enableFormEvent]="false"
                    [hasGroups]="false"
                    (filterDefChanged)="onConditionalStylingFilterChanges($event, $index)"
                    (filterRemoved)="removeConditionalStylingFilter($event)"
                  >
                    <div
                      additional-actions
                      class="pl-2 flex flex-row justify-evenly items-center gap-3 transform scale-95"
                    >
                      <mat-slide-toggle formControlName="is_bold"
                        ><span class="font-semibold">Bold</span></mat-slide-toggle
                      >
                      <ts-color-popover formControlName="color" [colorOptions]="accountColors"></ts-color-popover>
                    </div>
                  </ts-filter-list-item>
                </div>
              </div>
            </form>
          }
        }
        <ts-button variant="secondary" icon="add" type="icon" (click)="addConditionalStylingRule()"
          >Add Conditional</ts-button
        >
      </div>
    } @else {
      <span class="italic text-cool-gray-400">This field doesn't support conditional styling at this moment.</span>
    }
  </section>
}
